import { PLATFORM_ADMIN } from '../../constants/roles';

export default (() => {
    const forOfficer = (officer) => officer.roles[officer.roles.length - 1];

    const isPlatformAdmin = (user) =>
        user.roles.some((role) => role.id === PLATFORM_ADMIN);

    return {
        forOfficer,
        isPlatformAdmin,
    };
})();
